// Single source of truth for page-level role access.
// null = every authenticated role. super_admin always passes.
export const PAGE_ROLES = {
  '/dashboard':         ['director', 'coo', 'cfo', 'finance_manager', 'accountant', 'department_manager', 'auditor'],
  '/payment-requests':  ['director', 'cfo', 'finance_manager', 'accountant', 'department_manager', 'auditor'],
  '/transactions':      ['cfo', 'finance_manager', 'accountant', 'department_manager', 'auditor'],
  '/bank-accounts':     ['cfo', 'finance_manager', 'accountant', 'auditor'],
  '/daily-collections': ['cfo', 'finance_manager', 'accountant', 'auditor'],
  '/cash-management':   ['cfo', 'finance_manager', 'accountant', 'auditor'],
  '/vendors':           ['cfo', 'finance_manager', 'accountant', 'department_manager', 'auditor'],
  '/inter-entity':      ['cfo', 'finance_manager', 'accountant', 'auditor'],
  '/tasks':             ['director', 'coo', 'cfo', 'finance_manager', 'accountant', 'department_manager', 'auditor', 'staff', 'hr', 'manager'],
  '/reimbursements':    null,
  '/reporting':         null,
  '/assistant':         ['director', 'coo', 'cfo', 'finance_manager', 'accountant', 'department_manager', 'auditor', 'hr', 'manager', 'staff'],
  '/staff-hr':          ['hr', 'cfo', 'finance_manager', 'director', 'coo'],
  '/store-dashboard':   ['hr', 'cfo', 'finance_manager', 'accountant', 'director', 'coo', 'manager'],
  '/duty-roster':       ['hr', 'finance_manager', 'director', 'coo'],
  '/sale-corrections':  ['cfo', 'finance_manager', 'accountant', 'director', 'auditor'],
  '/data-health':       ['cfo', 'finance_manager', 'accountant'],
  '/directors':         ['finance_manager', 'director'],
  '/vehicles':          ['cfo', 'finance_manager', 'accountant', 'department_manager', 'auditor'],
  '/salary':            ['cfo', 'finance_manager', 'accountant'],
  '/reports':           ['director', 'coo', 'cfo', 'finance_manager', 'accountant', 'auditor'],
  '/entities':          ['cfo', 'finance_manager', 'director', 'coo'],
  '/users':             ['cfo', 'finance_manager'],
  '/audit':             ['director', 'cfo', 'auditor'],
  '/access-review':     [],
  '/backups':           [],
  '/records':           [],
  '/live-map':          [],
  '/my':                ['store_staff', 'staff', 'manager'],
  '/tv':                ['tv_display'],
  '/forms':             [],
};

export const canAccess = (role, path) => {
  if (!role) return false;
  if (role === 'super_admin') return true;
  const base = '/' + String(path || '').replace(/^\//, '').split('/')[0];
  const allowed = PAGE_ROLES[base];
  return !allowed || allowed.includes(role);
};

export const homeFor = (role) =>
  role === 'store_staff' ? '/my'
  : role === 'tv_display' ? '/tv'
  : role === 'hr' ? '/staff-hr'
  : role === 'staff' ? '/reimbursements'
  : role === 'manager' ? '/store-dashboard'
  : '/dashboard';

// Finance Manager can only create/manage Staff accounts on the Users page, and only a
// Super Admin can hand out Super Admin access.
export const assignableRoles = (myRole, allRoles) =>
  myRole === 'finance_manager' ? ['staff']
  : myRole === 'super_admin' ? allRoles
  : allRoles.filter(r => r !== 'super_admin');
